require('./helpers/bundle-manifest').register(JSON.parse("{\"Y15zO\":\"index.17466e3e.js\",\"a2sBv\":\"raskour-logo.58c3949c.svg\"}"));